module.exports = __webpack_public_path__ + "static/media/loader_black.1ec867c5.svg";